<template>
  <VBottomSheet
    :value="state.sheet"
    persistent
  >
    <VLayout
      row
      wrap
    >
      <VFlex>
        <VCard class="pb-5">
          <VToolbar
            color="primary"
            class="mb-3"
            dark
          >
            <VToolbarTitle>{{ $t('form.filters') }}</VToolbarTitle>
            <VSpacer />
            <VBtn
              icon
              @click="$emit('apply', getFilters())"
            >
              <VIcon>done</VIcon>
            </VBtn>
          </VToolbar>
          <VLayout
            row
            wrap
          >
            <VList
              class="flex xs6 scroll-y"
            >
              <VListTile>
                <Countries
                  v-model="selectedCountries"
                  multiple
                  chips
                  persistent
                  clearable
                  single-line
                />
              </VListTile>
              <VListTile>
                <Device
                  v-model="selectedDevice"
                  :menu-props="{
                    auto: true
                  }"
                  single-line
                  multiple
                  hide-details
                  clearable
                />
              </VListTile>
              <VListTile>
                <Os
                  v-if="selectedDevice.length"
                  v-model="selectedOs"
                  :devices="selectedDevice"
                  height="auto"
                  menu-props="auto"
                  multiple
                  clearable
                  chips
                />
              </VListTile>
              <VListTile class="mb-1 group-by-header">
                <VSubheader>{{ $t('form.groupBy') }}</VSubheader>
              </VListTile>
              <VListTile class="mb-1">
                <VSwitch
                  v-model="groupBy"
                  :label="$t('statistic.eventDate')"
                  value="eventDate"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('form.siteId')"
                  value="siteId"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('form.country')"
                  value="country"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('statistic.loss_reason')"
                  value="loss_reason"
                />
              </VListTile>
              <VListTile class="mb-1">
                <VSwitch
                  v-model="groupBy"
                  :label="$t('headers.device')"
                  value="device"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('headers.os')"
                  value="os"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('form.browser')"
                  value="browser"
                />
                <VSwitch
                  v-model="groupBy"
                  :label="$t('form.crid')"
                  value="crid"
                />
              </VListTile>
              <VListTile
                v-for="(item, index) in filterModel.slice(0, filterModel.length-3)"
                :key="index"
                row
                wrap
              >
                <VFlex
                  pl-2
                  xs4
                >
                  <VTextField
                    :value="$t('statistic.' + item)"
                    readonly
                    disabled
                  />
                </VFlex>
                <VFlex
                  v-if="compareModel[item]"
                  xs2
                >
                  <VSelect
                    v-model="compareModel[item].compare"
                    :items="compare"
                    label="Compare"
                  />
                </VFlex>
                <VFlex
                  v-if="compareModel[item]"
                  xs5
                  offset-xs1
                >
                  <VTextField
                    v-model.number="compareModel[item].value"
                    type="number"
                    min="0"
                    clearable
                  />
                </VFlex>
              </VListTile>
            </VList>

            <VList
              class="flex xs5 offset-xs1 scroll-y"
            >
              <VSubheader>{{ $t('form.show') }}</VSubheader>
              <VListTile
                v-for="(item, index) in filterModel"
                :key="index"
                row
                wrap
              >
                <VFlex
                  pl-2
                  xs4
                >
                  <VSwitch
                    v-model="visible"
                    :value="item"
                    :label="$t('statistic.' + item)"
                  />
                </VFlex>
              </VListTile>
            </VList>
          </VLayout>
        </VCard>
      </VFlex>
    </VLayout>
  </VBottomSheet>
</template>
<script>
import Countries from '@/app/components/Countries';
import Device from '@/app/components/Device';
import Os from '@/app/components/Os';
import SiteDomainDsp from '@/app/components/SiteDomainDsp';
import compareModel from './compareModel';

const EVENT_DATE = 'eventDate';
const filter = [
  'requests',
  'responses',
  'wins',
  'avgCPM',
  'clicks',
  'spent',
  'loss_reason',
  'ctr',
  'cpc',
];
export default {
  name: 'StatisticFilters',
  inject: ['state'],
  components: {
    Countries,
    Device,
    Os,
    SiteDomainDsp,
  },
  data() {
    return {
      selectedCountries: [],
      selectedDevice: [],
      selectedOs: [],
      groupBy: [EVENT_DATE],
      compare: ['<=', '>=', '='],
      compareModel,
      filterModel: [...filter],
      visible: [...filter],
    };
  },
  computed: {
    hidden() {
      return filter.filter(item => !this.visible.includes(item));
    },
  },
  watch: {
    groupBy(value) {
      if ((value && value.length === 0) || value === undefined) {
        value.push(EVENT_DATE);
      }
    },
  },
  methods: {
    getFilters() {
      return {
        hidden: this.hidden,
        selectedCountries: this.selectedCountries,
        selectedDevice: this.selectedDevice,
        selectedOs: this.selectedOs,
        groupBy: this.groupBy,
        compare: this.compareModel,
      };
    },
  },
};
</script>
